import { defineComponent, ref, watchEffect } from 'vue';
import { collapsePanelProps } from './commonProps';
import classNames from '../_util/classNames';
export default defineComponent({
    compatConfig: { MODE: 3 },
    name: 'PanelContent',
    props: collapsePanelProps(),
    setup(props, { slots }) {
        const rendered = ref(false);
        watchEffect(() => {
            if (props.isActive || props.forceRender) {
                rendered.value = true;
            }
        });
        return () => {
            if (!rendered.value)
                return null;
            const { prefixCls, isActive, role, contentBoxClass, contentBoxStyle, contentClass, contentStyle, } = props;
            return (<div ref={ref} style={contentStyle} class={classNames(`${prefixCls}-content`, {
                    [`${prefixCls}-content-active`]: isActive,
                    [`${prefixCls}-content-inactive`]: !isActive,
                }, contentClass)} role={role}>
          <div style={contentBoxStyle} class={classNames(`${prefixCls}-content-box`, contentBoxClass)}>
            {slots.default?.()}
          </div>
        </div>);
        };
    },
});
